module.exports = __webpack_public_path__ + "img/20231016.432fe59c.png";